const pluggyConnectorsMap = [
  {
    bankCode: 1, // Ágora + BB
    types: [
      {
        type: 'PF',
        connectorIds: [620, 611, 673]
      },
      {
        type: 'PJ',
        connectorIds: [781, 662]
      }
    ]
  },
  {
    bankCode: 107, // BMG
    types: [
      {
        type: 'PF',
        connectorIds: [652]
      },
      {
        type: 'PJ',
        connectorIds: [666]
      }
    ]
  },
  {
    bankCode: 335, // Digio/Uber Conta
    types: [
      {
        type: 'PF',
        connectorIds: [653, 674]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 4, // Banco do Nordeste
    types: [
      {
        type: 'PF',
        connectorIds: [671]
      },
      {
        type: 'PJ',
        connectorIds: [672]
      }
    ]
  },
  {
    bankCode: 623, // Pan
    types: [
      {
        type: 'PF',
        connectorIds: [657]
      }
    ]
  },
  {
    bankCode: 611, // Banco Paulista
    types: [
      {
        type: 'PF',
        connectorIds: [705]
      },
      {
        type: 'PJ',
        connectorIds: [706]
      }
    ]
  },
  {
    bankCode: 637, // Spfisa
    types: [
      {
        type: 'PF',
        connectorIds: [714]
      },
      {
        type: 'PJ',
        connectorIds: [715]
      }
    ]
  },
  {
    bankCode: 41, // Banrisul
    types: [
      {
        type: 'PF',
        connectorIds: [659]
      },
      {
        type: 'PJ',
        connectorIds: [660]
      }
    ]
  },
  {
    bankCode: 237, // Bradesco/Next
    types: [
      {
        type: 'PF',
        connectorIds: [603, 656]
      },
      {
        type: 'PJ',
        connectorIds: [609, 801]
      }
    ]
  },
  {
    bankCode: 208, // BTG
    types: [
      {
        type: 'PF',
        connectorIds: [675, 614]
      },
      {
        type: 'PJ',
        connectorIds: [655, 779]
      }
    ]
  },
  {
    bankCode: 413, // BV
    types: [
      {
        type: 'PF',
        connectorIds: [716, 717, 719]
      },
      {
        type: 'PJ',
        connectorIds: [718]
      }
    ]
  },
  {
    bankCode: 104, // Caixa
    types: [
      {
        type: 'PF',
        connectorIds: [619, 783]
      },
      {
        type: 'PJ',
        connectorIds: [616]
      }
    ]
  },
  {
    bankCode: 745, // Citi
    types: [
      {
        type: 'PF',
        connectorIds: []
      },
      {
        type: 'PJ',
        connectorIds: [710]
      }
    ]
  },
  {
    bankCode: 321, // EQI
    types: [
      {
        type: 'PF',
        connectorIds: [802]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 9999, // InfinitePay
    types: [
      {
        type: 'PF',
        connectorIds: [777]
      },
      {
        type: 'PJ',
        connectorIds: [778]
      }
    ]
  },
  {
    bankCode: 9998, // Íon
    types: [
      {
        type: 'PF',
        connectorIds: [677]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 341, // Itaú
    types: [
      {
        type: 'PF',
        connectorIds: [601, 647, 638]
      },
      {
        type: 'PJ',
        connectorIds: [668, 618, 786]
      }
    ]
  },
  {
    bankCode: 184, // Itaú BBA
    types: [
      {
        type: 'PF',
        connectorIds: []
      },
      {
        type: 'PJ',
        connectorIds: [794]
      }
    ]
  },
  {
    bankCode: 9997, // Méliuz
    types: [
      {
        type: 'PF',
        connectorIds: [720]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 323, // Mercado Pago
    types: [
      {
        type: 'PF',
        connectorIds: [606]
      },
      {
        type: 'PJ',
        connectorIds: [665]
      }
    ]
  },
  {
    bankCode: 9996, // Monte Bravo
    types: [
      {
        type: 'PF',
        connectorIds: [795]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 354, // Necton
    types: [
      {
        type: 'PF',
        connectorIds: [793]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 536, // Neon
    types: [
      {
        type: 'PF',
        connectorIds: [689]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 260, // Nu
    types: [
      {
        type: 'PF',
        connectorIds: [612]
      },
      {
        type: 'PJ',
        connectorIds: [664]
      }
    ]
  },
  {
    bankCode: 9995, // Pague Veloz Serasa
    types: [
      {
        type: 'PF',
        connectorIds: [814]
      },
      {
        type: 'PJ',
        connectorIds: [815]
      }
    ]
  },
  {
    bankCode: 380, // Picpay
    types: [
      {
        type: 'PF',
        connectorIds: [651]
      },
      {
        type: 'PJ',
        connectorIds: [713]
      }
    ]
  },
  {
    bankCode: 9994, // Player's Bank
    types: [
      {
        type: 'PF',
        connectorIds: [765]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 9993, // Porto Bank
    types: [
      {
        type: 'PF',
        connectorIds: [800]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 9992, // RecargaPay
    types: [
      {
        type: 'PF',
        connectorIds: [767]
      },
      {
        type: 'PJ',
        connectorIds: [768]
      }
    ]
  },
  {
    bankCode: 509, // Rede Celcoin
    types: [
      {
        type: 'PF',
        connectorIds: [696]
      },
      {
        type: 'PJ',
        connectorIds: [811]
      }
    ]
  },
  {
    bankCode: 102, // Clear/Rico/XP
    types: [
      {
        type: 'PF',
        connectorIds: [623, 605]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 422, // Safra
    types: [
      {
        type: 'PF',
        connectorIds: [629, 711, 708]
      },
      {
        type: 'PJ',
        connectorIds: [697, 712, 709]
      }
    ]
  },
  {
    bankCode: 33, // Santander
    types: [
      {
        type: 'PF',
        connectorIds: [608, 798, 812]
      },
      {
        type: 'PJ',
        connectorIds: [799, 813, 621]
      }
    ]
  },
  {
    bankCode: 756, // Sicoob
    types: [
      {
        type: 'PF',
        connectorIds: [658]
      },
      {
        type: 'PJ',
        connectorIds: [628]
      }
    ]
  },
  {
    bankCode: 748, // Sicred/Woop
    types: [
      {
        type: 'PF',
        connectorIds: [661, 676]
      },
      {
        type: 'PJ',
        connectorIds: [627]
      }
    ]
  },
  {
    bankCode: 197, // Stone pgmt
    types: [
      {
        type: 'PF',
        connectorIds: [787]
      },
      {
        type: 'PJ',
        connectorIds: [788]
      }
    ]
  },
  {
    bankCode: 352, // Toro
    types: [
      {
        type: 'PF',
        connectorIds: [796]
      },
      {
        type: 'PJ',
        connectorIds: [797]
      }
    ]
  },
  {
    bankCode: 136, // Unicred
    types: [
      {
        type: 'PF',
        connectorIds: [663]
      },
      {
        type: 'PJ',
        connectorIds: [670]
      }
    ]
  },
  {
    bankCode: 348, // XP Banking
    types: [
      {
        type: 'PF',
        connectorIds: [602]
      },
      {
        type: 'PJ',
        connectorIds: [702]
      }
    ]
  },
  {
    bankCode: 290, // PagSeguro
    types: [
      {
        type: 'PF',
        connectorIds: [692]
      },
      {
        type: 'PJ',
        connectorIds: [816]
      }
    ]
  },
  {
    bankCode: 70, // Banco BRB
    types: [
      {
        type: 'PF',
        connectorIds: [817]
      },
      {
        type: 'PJ',
        connectorIds: [818]
      }
    ]
  },
  {
    bankCode: 389, // Banco Mercantiol do Brasil
    types: [
      {
        type: 'PF',
        connectorIds: [742]
      },
      {
        type: 'PJ',
        connectorIds: [819]
      }
    ]
  },
  {
    bankCode: 336, // C6 Bank
    types: [
      {
        type: 'PF',
        connectorIds: [626]
      },
      {
        type: 'PJ',
        connectorIds: [726]
      }
    ]
  },
  {
    bankCode: 69, // Crefisa
    types: [
      {
        type: 'PF',
        connectorIds: [750]
      },
      {
        type: 'PJ',
        connectorIds: [860]
      }
    ]
  },
  {
    bankCode: 77, // Inter
    types: [
      {
        type: 'PF',
        connectorIds: [823]
      },
      {
        type: 'PJ',
        connectorIds: [824]
      }
    ]
  },
  {
    bankCode: 301, // BPP/99Pay
    types: [
      {
        type: 'PF',
        connectorIds: [804]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 82, // Banco Master
    types: [
      {
        type: 'PF',
        connectorIds: [680]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 63, // Bradescard
    types: [
      {
        type: 'PF',
        connectorIds: [775]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 368, // Cartao Atacadao/Carrefour
    types: [
      {
        type: 'PF',
        connectorIds: [821, 822]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 204, // Cartao Sam's Club
    types: [
      {
        type: 'PF',
        connectorIds: [820]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  },
  {
    bankCode: 358, // MidWay
    types: [
      {
        type: 'PF',
        connectorIds: [688]
      },
      {
        type: 'PJ',
        connectorIds: []
      }
    ]
  }
]

function getPluggyConnectorCodeByCdBankPersonType (bankCode, type) {
  // Encontra o item correspondente ao código do banco fornecido
  const item = pluggyConnectorsMap.find(dado => dado.bankCode === bankCode)
  if (!item) {
    return [] // Retorna uma lista vazia se o código não for encontrado
  }

  if (type) {
    // Encontra o type dentro do item
    const typeItem = item.types.find(t => t.type === type)

    return typeItem ? flatItemsConnectorIds({types: [{...typeItem}]}) : [] // Retorna os connectorIds ou uma lista vazia
  } else {
    return flatItemsConnectorIds(item)
  }
}

function flatItemsConnectorIds (item) {
  const allConnectors = item.types.flatMap(t => t.connectorIds)
  return [...new Set(allConnectors)]
}

export {
  getPluggyConnectorCodeByCdBankPersonType
}



// WEBPACK FOOTER //
// ./client/enum/pluggyConnectorsMap.js